import React from "react";
/**
 * Utility function to get the appropriate image based on device width
 * @param {string} mobileImage - The mobile image URL
 * @param {string} defaultImage - The default/desktop image URL
 * @param {number} breakpoint - The breakpoint width (default: 600px)
 * @returns {string} - The appropriate image URL
 */
export const getResponsiveImage = (
  mobileImage,
  defaultImage,
  breakpoint = 600
) => {
  // Check if we're on the client side
  if (typeof window === "undefined") {
    // console.log(
    //   "🖼️ [ResponsiveImage] Server-side rendering, using default image:",
    //   defaultImage
    // );
    return defaultImage;
  }

  const isMobile = window.innerWidth <= breakpoint;
  const windowWidth = window.innerWidth;

  // console.log(`Is Mobile: ${isMobile}`);
  // console.log("🖼️ [ResponsiveImage] Mobile image available:", !!mobileImage);
  // console.log("🖼️ [ResponsiveImage] Default image:", defaultImage);

  // If mobile and mobileImage exists, use mobileImage
  if (isMobile && mobileImage) {
    // console.log("🖼️ [ResponsiveImage] ✅ Selected: MOBILE IMAGE", mobileImage);
    return mobileImage;
  }

  // Otherwise, use defaultImage
  // console.log("🖼️ [ResponsiveImage] ✅ Selected: DEFAULT IMAGE", defaultImage);
  return defaultImage;
};

/**
 * Hook to get responsive image based on window width
 * @param {string} mobileImage - The mobile image URL
 * @param {string} defaultImage - The default/desktop image URL
 * @param {number} breakpoint - The breakpoint width (default: 600px)
 * @returns {string} - The appropriate image URL
 */
export const useResponsiveImage = (
  mobileImage,
  defaultImage,
  breakpoint = 600
) => {
  const [imageUrl, setImageUrl] = React.useState(() =>
    getResponsiveImage(mobileImage, defaultImage, breakpoint)
  );

  React.useEffect(() => {
    const updateImage = () => {
      //   console.log(
      //     "🖼️ [useResponsiveImage] Window resize detected, updating image..."
      //   );
      const newImageUrl = getResponsiveImage(
        mobileImage,
        defaultImage,
        breakpoint
      );
      setImageUrl(newImageUrl);
    };

    // Set initial image
    // console.log("🖼️ [useResponsiveImage] Setting initial image...");
    updateImage();

    // Add resize listener
    window.addEventListener("resize", updateImage);

    // Cleanup
    return () => {
      //   console.log("🖼️ [useResponsiveImage] Cleaning up resize listener");
      window.removeEventListener("resize", updateImage);
    };
  }, [mobileImage, defaultImage, breakpoint]);

  return imageUrl;
};
